<div class="popup-container">
	<div class="popup-header">
		<app-icon
			class="header-icon"
			[color]="'var(--color-white)'"
			[size]="'38px'"
			[viewbox]="'0 0 40 40'"
			[name]="'figma-warning'"
			[lineWidth]="'2.75px'"
		></app-icon>
		<span class="header-text">WARNING!</span>
	</div>
	<div class="message-container">
		<div class="confirmationMessage" [innerHTML]="confirmationMessage"></div>
	</div>
	<div class="button-container">
		<button id="cancelBtn" mat-button class="back-btn" [mat-dialog-close]="false">
			<span class="button-text">CANCEL</span>
		</button>
		<button id="confirmBtn" mat-button class="confirm-btn" [mat-dialog-close]="true" cdkFocusInitial>
			<span class="button-text">YES, DEACTIVATE ({{ data.serviceCount }})</span>
		</button>
	</div>
</div>
